module.exports = __webpack_public_path__ + "img/fwzc-01.9b2f7860.jpg";